import React from 'react';
import { Box, Grid, Paper, Switch, Typography } from '@mui/material';
import { PermissionModuleConfig } from '../../../shared/config/permissions-config';

interface MenuPermissionsBoxProps {
    configs: PermissionModuleConfig[];
    permissions: any;
    onChange: (moduleKey: string, actionKey: string, value: boolean) => void;
    display?: string;
}

export const MenuPermissionsBox: React.FC<MenuPermissionsBoxProps> = ({ configs, permissions, onChange, display }) => {
    if (display === 'none') return null;

    return (
        <Paper elevation={0} sx={{ padding: 2, marginBottom: 2, backgroundColor: '#f5f5f5', borderRadius: 2 }}>
            <Typography variant="subtitle1" fontWeight="bold" gutterBottom sx={{ color: '#333' }}>
                Acesso aos Menus
            </Typography>
            <Grid container spacing={2}>
                {configs.map((config) => {
                    return config.actions.map((actionItem) => {
                        const modulePermissions = permissions?.[config.key] || {};
                        return (
                            <Grid
                                item
                                xs={12} sm={6} md={3}
                                key={`${config.key}-${actionItem.action}`}
                                sx={{ display: 'flex', alignItems: 'center' }}
                            >
                                <Switch
                                    color="primary"
                                    size="small"
                                    checked={!!modulePermissions[actionItem.action]}
                                    onChange={(e) => onChange(config.key as string, actionItem.action, e.target.checked)}
                                    sx={{ marginRight: 1 }}
                                />
                                <Typography variant="body2" sx={{ color: '#555' }}>{config.label}</Typography>
                            </Grid>
                        );
                    });
                })}
            </Grid>
        </Paper>
    );
};
